import type { LucideIcon } from 'lucide-react';

/** The one way icons enter the app: a 1.75-stroke lucide glyph inheriting
 *  currentColor, so the only hues on screen are the brand's and icons track
 *  their label's hover state. Size 16 default, 14 in dense rows/cards.
 *  Color only via className — never a color prop. */
export function Icon({ i: I, size = 16, className = '' }:
  { i: LucideIcon; size?: 14 | 16 | 20; className?: string }) {
  return <I size={size} strokeWidth={1.75} className={`shrink-0 ${className}`} aria-hidden />;
}
